import { ColumnTable, Icon } from '@octano/global-ui';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { CourseFormContext } from '../providers/CourseProvider';
import { CourseFormMode } from '../types';

export const useColumnsLearningUnits = ({
  onDelete,
  onEdit,
}: {
  onDelete: (index: number) => Promise<void>;
  onEdit: (index: number) => void;
}) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);
  const { mode } = useContext(CourseFormContext);

  const canEdit = useMemo(() => mode !== CourseFormMode.WATCH, [mode]);
  return useMemo<ColumnTable<any>[]>(() => {
    return [
      {
        columnName: 'title',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`learningUnit.table.columns.title`),
        width: '42%',
      },
      {
        columnName: 'hours',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`learningUnit.table.columns.hours`),
        width: '42%',
      },
      {
        columnName: 'actions',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        width: '15%',
        headerText: t(`learningUnit.table.columns.actions`),
        cellFormat: ({ index }) => (
          <div className="d-flex  justify-content-center">
            {}
            <button
              type="button"
              className="btn btn-primary bg-transparent border-0"
              onClick={() => {
                if (canEdit) {
                  onEdit(index);
                }
              }}
            >
              <Icon
                size="15"
                name="edit"
                color={canEdit ? 'primary' : 'disabled'}
              />
            </button>
            <button
              type="button"
              className="btn btn-primary bg-transparent border-0"
              onClick={async () => {
                if (canEdit) {
                  await onDelete(index);
                }
              }}
            >
              <Icon
                size="15"
                name="trash"
                color={canEdit ? 'primary' : 'disabled'}
              />
            </button>
          </div>
        ),
      },
    ];
  }, [t, onDelete, onEdit, canEdit]);
};
